const navigationMobile = () => {
	$("#button--mobile").on("click", () => {
		$("body").toggleClass("menu-open");
		document.getElementById("navigation-overlay").style.height = $(
			"body",
		).hasClass("menu-open")
			? "100%"
			: "0%";
	});
};

const navigationSize = () => {
	const position = $(window).scrollTop();
	if (position > 220) {
		$("body").addClass("header-small");
	} else {
		$("body").removeClass("header-small");
	}
	$(window).on("scroll", (e) => {
		if ($(e.currentTarget).scrollTop() > 220) {
			$("body").addClass("header-small");
		} else {
			$("body").removeClass("header-small");
		}
	});
};

const navigationDropdown = () => {
	const viewport = $(window).width();
	if (viewport < 576) {
		$("#navigation-main li[data-navsub] > a").on("click", (e) => {
			$(e.currentTarget).next().toggle();
			return false;
		});
	} else {
		$("#navigation-main li[data-navsub] > a").on("click", (e) => {
			const navSub = $(e.currentTarget).parent();
			const isFocus = navSub.hasClass("focus");
			$("#navigation-main li[data-navsub]").removeClass("focus");
			if (!isFocus) {
				navSub.addClass("focus");
			}
			e.stopPropagation();
			return false;
		});
		$("html").on("click", () => {
			$("#navigation-main li[data-navsub]").removeClass("focus");
		});
	}
};

const scrollTop = () => {
	const domElm = $("#button--scroll-top");
	domElm.fadeOut(0);
	$(window).on("scroll", (e) => {
		if ($(e.currentTarget).scrollTop() > 220) {
			domElm.fadeIn(300);
		} else {
			domElm.fadeOut(300);
		}
	});
	domElm.on("click", () => {
		$("html, body").animate(
			{
				scrollTop: 0,
			},
			"500",
		);
		return false;
	});
};

const reservationToggle = () => {
	const form = $(".form-resa-inner-page, .form-resa");
	const btn = $(".trigger-reservation-page");
	if ($("#header-reservation").length) {
		form.hide();
	}
	btn.on("click", () => {
		btn.toggleClass("open");
		if ($("#header-reservation") === null) {
			btn.parent().hide();
		}
		const headerReservationHeight = $("#header-reservation").innerHeight();
		form.show();
		setTimeout(() => {
			const positionForm =
				$(".form-resa-inner-page").offset().top -
				(headerReservationHeight === undefined ? 0 : headerReservationHeight);
			$("html, body").animate(
				{
					scrollTop: positionForm,
				},
				{
					duration: 500,
					complete() {
						setTimeout(() => {
              if (!$('body').hasClass('except-resa')) {
                $('#date-start').click();
              }
						}, 200);
					},
				},
			);
		});

		return false;
	});
};

const reservationHeaderPadding = () => {
	const computePadding = () => {
		if ($("#header-reservation") !== null) {
			const headerReservationHeight = $("#header-reservation").innerHeight();
			$("body").css("paddingTop", headerReservationHeight);
		}
	};

	computePadding();
	$(window).on("resize", () => {
		computePadding();
	});
};

// Function to show/hide the place-return element when button is clicked
const toggleDifferentPlace = () => {
	// Initially hide the return place selector
	$(".place-return").hide();

	// Add click handler for the button
	$(".button-difference-place").on("click", (e) => {
		e.preventDefault();
		// Toggle visibility
		$(".place-return").toggle();
		$(".resa-submit").toggleClass("resa-back-opened");
		$(".reservation-wrapper > .container").toggleClass(
			"resa-back-opened-container",
		);

		// Toggle the icon between + and -
		const icon = $(e.currentTarget).find(".material-icons");
		icon.text(icon.text() === "add" ? "remove" : "add");
	});
};

const navigationOverlaySubmenu = () => {
	$(".overlay-content .has-submenu").on("click", function (e) {
		e.preventDefault();
		const $trigger = $(this);
		const $subMenu = $trigger.next(".sub-menu");
		const isOpen = $subMenu.hasClass("open");

		// Accordion: close all
		$(".overlay-content .sub-menu.open").removeClass("open");
		$(".overlay-content .has-submenu.open").removeClass("open");

		if (!isOpen) {
			$subMenu.addClass("open");
			$trigger.addClass("open");
		}
	});
};

navigationMobile();
navigationOverlaySubmenu();
navigationDropdown();
navigationSize();
scrollTop();
reservationToggle();
reservationHeaderPadding();
toggleDifferentPlace();

// Function to add/remove 'filled' class on promo input when it contains text
const handlePromoInput = () => {
	const promoInput = document.querySelector(".promo-input");
	if (!promoInput) return;

	// Check on initial load (in case field has value)
	if (promoInput.value.trim() !== "") {
		promoInput.classList.add("filled");
	}

	// Add event listener for input changes
	promoInput.addEventListener("input", (e) => {
		if (e.target.value.trim() !== "") {
			e.target.classList.add("filled");
		} else {
			e.target.classList.remove("filled");
		}
	});
};

// Execute promo input handler
handlePromoInput();

const categoryFilter = () => {
	// Desktop: vélo label opens link without activating radio
	document
		.querySelectorAll(".category-filter__btn[data-href]")
		.forEach((label) => {
			label.addEventListener("click", (e) => {
				e.preventDefault();
				window.open(label.dataset.href, "_blank");
			});
		});

	// Mobile: custom dropdown
	const dropdown = document.querySelector(".category-filter-mobile");
	if (!dropdown) return;

	const trigger = dropdown.querySelector(".category-filter-mobile__trigger");
	const menu = dropdown.querySelector(".category-filter-mobile__menu");
	const valueEl = dropdown.querySelector(".category-filter-mobile__value");
	const options = dropdown.querySelectorAll(".category-filter-mobile__option");

	trigger.addEventListener("click", () => {
		const isOpen = menu.classList.contains("is-open");
		menu.classList.toggle("is-open", !isOpen);
		trigger.setAttribute("aria-expanded", String(!isOpen));
	});

	options.forEach((opt) => {
		opt.addEventListener("click", () => {
			if (opt.dataset.href) {
				window.open(opt.dataset.href, "_blank");
				return;
			}
			options.forEach((o) => o.classList.remove("is-selected"));
			opt.classList.add("is-selected");
			valueEl.textContent = opt.textContent;
			menu.classList.remove("is-open");
			trigger.setAttribute("aria-expanded", "false");
		});
	});

	document.addEventListener("click", (e) => {
		if (!dropdown.contains(e.target)) {
			menu.classList.remove("is-open");
			trigger.setAttribute("aria-expanded", "false");
		}
	});
};

categoryFilter();
